const GeneralFunctions = {
  capitalizeString(string) {
    const { titalizeWord } = GeneralFunctions
    if (!Boolean(string)) {
      return '';
    }
    const array = string.indexOf(' ') >= 0 ? string.split(' ') : [string];
    let newString = [];
    array.forEach(w => newString.push(titalizeWord(w)));
    return newString.join(newString.length > 1 ? ' ' : '');
  },
  titalizeWord(word) {
    return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
  },
  cleanNumberCurrency: value => (
    typeof value !== 'number' ? Number(value.replace(/[^0-9.]+/g, '')) : value
  ),
  trimString(str) {
    return str.trim()
  }
};

export default GeneralFunctions
